import React from 'react';

import CompareProductContent from '../Modals/Content/ModalContentCompareProduct';
import ContentsDifference from '../Modals/Content/ModalContentContentsDifference';
import PostcodeRisk from '../Modals/Content/ModalContentPostcodeRisk';
import SaveQuote from '../Modals/Content/ModalContentSaveQuote';
import ModalContentMSP from '../Modals/Content/ModalContentMSP';
import ModalContentAstHelpText from '../Modals/Content/ModalContentAstHelpText';
import MHLModal from '../Modals/MHLModal';
import ModalTheftExclusion from '../Modals/Content/ModalTheftExclusion';

let classNames  = require('classnames');
let FaCross = require('react-icons/lib/fa/close');

const Modal = React.createClass({
    propTypes: {
        isActive: React.PropTypes.bool.isRequired,
        bodyTemplate: React.PropTypes.string.isRequired,
        templateProps: React.PropTypes.object,
        title: React.PropTypes.string,
        closeFunction: React.PropTypes.func.isRequired,
        hideLogin: React.PropTypes.func,
        closeButton: React.PropTypes.object,
        setActiveValue: React.PropTypes.func,
        noFooter: React.PropTypes.bool,
        clearEmail: React.PropTypes.func,
        getEmail: React.PropTypes.func,
        hasFooter: React.PropTypes.bool,
        isAlertModal: React.PropTypes.bool,
        mountCustomerDetails : React.PropTypes.func,
        forceRerender : React.PropTypes.func,
    },

    defaultProps: {
        isActive: false,
    },

    componentDidMount() {
        document.body.classList.toggle('no-scroll', this.props.isActive);
    },

    componentWillReceiveProps(nextProps) {
        document.body.classList.toggle('no-scroll', nextProps.isActive);
    },

    componentWillUnmount() {
        document.body.classList.remove('no-scroll');
    },

    render() {
        let modalClasses = classNames({
            'has-footer': (this.props.hasFooter ? true : false),
            'alert': (this.props.isAlertModal ? true : false),
        });
        return (
            <modal-container class={this.props.isActive ? 'modal-active' : null}>
                <modal className={modalClasses}>
                    <div className="modal-header">
                        {this.props.title}
                        <a className="close-cross" onClick={this.props.closeFunction}><FaCross /></a>
                    </div>
                    <div className="modal-body">
                        {this.props.bodyTemplate === 'msp' ?
                            <ModalContentMSP />
                        : null}
                        {this.props.bodyTemplate === 'theft' ?
                            <ModalTheftExclusion />
                        : null}
                        {this.props.bodyTemplate === 'mhl-login' ?
                            <MHLModal
                                closeFunction={this.props.closeFunction}
                                hideLogin={this.props.hideLogin}
                                emailAddress={this.props.templateProps.emailAddress}
                                mountCustomerDetails={this.props.mountCustomerDetails}
                                forceRerender={this.props.forceRerender}
                                getEmail={this.props.getEmail}
                                clearEmail={this.props.clearEmail}
                            />
                            : null}
                        {this.props.bodyTemplate === 'compare-product' ? <CompareProductContent /> : null}
                        {this.props.bodyTemplate === 'postcode-risk' && this.props.templateProps ?
                            <PostcodeRisk
                                exclusions={this.props.templateProps.exclusions}
                            /> : null}
                        {this.props.bodyTemplate === 'save-quote' ? <SaveQuote /> : null}
                        {this.props.bodyTemplate === 'compare-contents-cover' ?
                        <ContentsDifference
                            closeFunction={this.props.closeFunction}
                            setActiveValue={this.props.setActiveValue}
                        /> : null}

                        {this.props.bodyTemplate === 'ast-help-text' ?
                            <ModalContentAstHelpText />
                        : null}
                    </div>
                    {this.props.bodyTemplate !== 'mhl-login' && this.props.hasFooter === true ?
                    <div className="modal-footer">
                        {this.props.closeButton ?
                            <a onClick={this.props.closeFunction} className={this.props.closeButton.classes}>{this.props.closeButton.text}</a>
                        :
                            <a onClick={this.props.closeFunction} className="btn btn-default">OK</a>
                        }
                    </div>
                    : null}
                </modal>
            </modal-container>
        );
    }

});

export default Modal;



/** WEBPACK FOOTER **
 ** ./src/components/Fragments/Modal.js
 **/